// extracted by mini-css-extract-plugin
export default {"regulationContainer":"Regulation_regulationContainer__nuF+J","regulationText":"Regulation_regulationText__8ykDp"};